import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';

export interface NavItemProps {
  label: string;
  path: string;
  exact: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params?: Record<string, any>;
}

export const NavItem: React.FC<NavItemProps> = ({ label, path, exact, params }: NavItemProps): React.ReactElement => {
  const match = useRouteMatch({
    path,
    exact,
  });
  return (
    <li className={`nav-item ${match ? 'active' : ''}`}>
      <Link className="nav-link" to={{ pathname: path, state: params }}>
        {label}
      </Link>
    </li>
  );
};

export interface LinkItemProps {
  children: React.ReactNode;
  url: string;
}

export const LinkItem = ({ children, url }: LinkItemProps): React.ReactElement => {
  return (
    <li className="nav-item">
      <a href={url} className="nav-link" target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    </li>
  );
};
